import { useEffect, useState } from "react";
import { NAV_LINKS } from "@/data/content";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-[#E5E5E5]"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 flex items-center justify-between h-20">
        <a href="#hero" data-testid="navbar-logo" className="flex items-center gap-2">
          <span className="text-lg font-black tracking-tighter text-[#E60000]">RED</span>
          <span className="text-base font-medium tracking-tight text-[#0A0A0A] hidden sm:inline">
            Mercadotecnia
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-10">
          {NAV_LINKS.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                data-testid={`navbar-link-${link.href.replace("#", "")}`}
                className="relative text-sm font-medium text-[#525252] hover:text-[#0A0A0A] transition-colors duration-200 after:absolute after:left-0 after:-bottom-1.5 after:h-0.5 after:w-0 after:bg-[#E60000] after:transition-all after:duration-300 hover:after:w-full"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="https://www.redmercadotecnia.com"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="navbar-website"
          className="text-xs md:text-sm font-semibold tracking-wide text-[#0A0A0A] md:border-l md:border-[#E5E5E5] md:pl-6 hover:text-[#E60000] transition-colors duration-200"
        >
          redmercadotecnia.com
        </a>
      </nav>
    </header>
  );
};

export default Navbar;
